import { t } from "@lingui/macro";
import React from "react";
import type { ReactNode } from "react";
import { Image } from "react-native";

import {
  Box,
  HStack,
  Pressable,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { CloseIcon, ArrowLeftIcon } from "../../../components/icons_v2/general";

export type MobileNavigationBarProps = {
  leftAction?: "Back" | "Close" | null;
  onLeftActionClick?: () => void;
  title: string;
  subTitle?: string;
  clubLogoImageUrl?: string;
  rightElement?: ReactNode;
};

export const MobileNavigationBar = ({
  leftAction,
  onLeftActionClick,
  title,
  subTitle,
  clubLogoImageUrl,
  rightElement,
}: MobileNavigationBarProps) => {
  return (
    <HStack height={56} alignItems="center" gap={4} paddingHorizontal={2}>
      <LeftAction
        leftAction={leftAction}
        onLeftActionClick={onLeftActionClick}
      />
      <VStack flex={1} alignItems="center" justifyContent="center">
        {subTitle ? (
          <Text variant="mainTiny" color="text-secondary">
            {subTitle}
          </Text>
        ) : null}
        <Text variant="mainBaseSemiBold" color="text-primary">
          {title}
        </Text>
      </VStack>
      {rightElement ? (
        <HStack alignItems="center" gap={2}>
          {rightElement}
          {clubLogoImageUrl ? (
            <Image
              source={{ uri: clubLogoImageUrl }}
              style={{
                width: 56,
                height: 56,
                borderRadius: 8,
              }}
              resizeMode="cover"
              accessibilityLabel={t`Club logo`}
            />
          ) : null}
        </HStack>
      ) : clubLogoImageUrl ? (
        <Image
          source={{ uri: clubLogoImageUrl }}
          style={{
            width: 56,
            height: 56,
            borderRadius: 8,
          }}
          resizeMode="cover"
          accessibilityLabel={t`Club logo`}
        />
      ) : null}
    </HStack>
  );
};

const LeftAction = ({
  leftAction,
  onLeftActionClick,
}: {
  leftAction?: "Back" | "Close" | null;
  onLeftActionClick?: () => void;
}) => {
  if (!leftAction) {
    return <Box width={56} height={56} />;
  }

  const Icon = leftAction === "Back" ? ArrowLeftIcon : CloseIcon;
  const accessibilityLabel = leftAction === "Back" ? t`Go back` : t`Close`;

  return (
    <Pressable
      width={56}
      height={56}
      borderRadius="2"
      backgroundColor="button-alt-surface-neutral"
      justifyContent="center"
      alignItems="center"
      onPress={onLeftActionClick}
      accessibilityLabel={accessibilityLabel}
      role="button"
      _pressed={{
        opacity: 0.7,
      }}
    >
      <Icon width={16} height={16} color="text-primary" accessible={false} />
    </Pressable>
  );
};
